import { SOURCES } from '../../constants/map'

export const addSource = ({ map, source, data }) => {
  let options = {}

  if (source === SOURCES.earthquakes) options = {
    cluster: true,
    clusterMaxZoom: 14,
    clusterRadius: 50
  }

  map.addSource(source, {
    type: 'geojson',
    data,
    ...options
  });
};
